<template>
  <div class="version">
    <div class="file">
      <div ref="holder">
        <img class="material-icons" :src="icon">
      </div>
      <div class="info">
        <h3 :title="name">{{ name }}</h3>
        <p>{{ humanTime() }} | {{ humanSize() }}</p>
      </div>
    </div>
    <div class="buttons">
      <button v-if="this.size <= 50*1024*1024" @click="preview" :aria-label="$t('sidebar.preview')" :title="$t('sidebar.preview')" id="download-button" class="action">
        <eye-icon size="1.5x" class="custom-class"></eye-icon>
      </button>
      <button @click="download" :aria-label="$t('buttons.download')" :title="$t('buttons.download')" id="download-button" class="action">
        <download-icon size="1.5x" class="custom-class"></download-icon>
      </button>
      <button @click="deleteVersion" :aria-label="$t('buttons.delete')" :title="$t('buttons.delete')" id="download-button" class="action">
        <trash-2-icon size="1.5x" class="custom-class"></trash-2-icon>
      </button>
    </div>
  </div>
</template>

<script>
import { DownloadIcon, Trash2Icon, EyeIcon } from 'vue-feather-icons';
import filesize from 'filesize';
import moment from 'moment';
import { files as api } from '@/api';
import { mapMutations } from 'vuex';

export default {
  name: 'item-version',
  props: ['name', 'size', 'modified', 'handle', 'index'],
  components: {
    DownloadIcon,
    Trash2Icon,
    EyeIcon
  },
  computed: {
    icon () {
      const thisComponent = this;
      let extension = this.name.split('.');
      if (extension[1] == 'jpg' || extension[1] == 'jpeg' || extension[1] == 'png' || extension[1] == 'bmp' || extension[1] == 'heic' || extension[1] == 'heif') { 
        let thumbnailName = '///thumbnails/' + this.handle;
        if (!window.gRequestedThumbnails.has(thumbnailName))
        {
          let uri = Module.getObjectURL(thumbnailName);
          if (uri)
          {
            setTimeout(function() { 
              const holder = thisComponent.$refs.holder;
              if (holder) {
                holder.style.width = 'auto';
                holder.style.height = 'auto';
                holder.innerHTML='<img src="' + uri + '" style="filter: none;"  />';
              }
            }, 0);
          }
          else
          {
            window.gRequestedThumbnails.add(thumbnailName);
            let promise = ibb.downloadMetadata(this.handle, Module.MetadataType.META_THUMBNAIL.value, thumbnailName);
            promise.then(function(action) {
              if (!action.error.type)
              {
                window.gRequestedThumbnails.delete(thumbnailName);
                let uri = Module.getObjectURL(thumbnailName);
                const holder = thisComponent.$refs.holder;
                if (holder) {
                  holder.style.width = 'auto';
                  holder.style.height = 'auto';
                  holder.innerHTML='<img src="' + uri + '" style="filter: none; " />';
                }
              }
            });
          }
        }
        else {
          console.log('Thumbnail already requested');
        }
        return '/img/icons/WEBCLIENT_MimeTypes/ibbImage.svg';
      } else if (extension[extension.length - 1] == 'mp3' || extension[extension.length - 1] == 'wav' || extension[extension.length - 1] == 'flac') {
        return '/img/icons/WEBCLIENT_MimeTypes/ibbMusic.svg';
      } else if (extension[extension.length - 1] == 'avi' || extension[extension.length - 1] == 'mp4' || extension[extension.length - 1] == 'mkv' || extension[extension.length - 1] == 'mov' || extension[extension.length - 1] == 'flv') {
        return '/img/icons/WEBCLIENT_MimeTypes/ibbVideo.svg';
      } else if (extension[extension.length - 1] == 'txt') {
        return '/img/icons/WEBCLIENT_MimeTypes/ibbTxt.svg';
      } else if (extension[extension.length - 1] == 'pdf') {
        return '/img/icons/WEBCLIENT_MimeTypes/ibbPDF.svg';
      } else if (extension[extension.length - 1] == 'zip' || extension[extension.length - 1] == 'tar' || extension[extension.length - 1] == 'rar') {
        return '/img/icons/WEBCLIENT_MimeTypes/ibbZIP.svg';
      } else if (extension[extension.length - 1] == 'xls' || extension[extension.length - 1] == 'xlsx') {
        return '/img/icons/WEBCLIENT_MimeTypes/ibbXLS.svg';
      } else if (extension[extension.length - 1] == 'doc' || extension[extension.length - 1] == 'docx') {
        return '/img/icons/WEBCLIENT_MimeTypes/ibbDoc.svg';
      } else if (extension[extension.length - 1] == 'ppt' || extension[extension.length - 1] == 'pptx') {
        return '/img/icons/WEBCLIENT_MimeTypes/ibbPPT.svg';
      } else if (extension[extension.length - 1] == 'js' || extension[extension.length - 1] == 'css' || extension[extension.length - 1] == 'html' || extension[extension.length - 1] == 'vue' || extension[extension.length - 1] == 'java') {
        return '/img/icons/WEBCLIENT_MimeTypes/ibbCode.svg';
      }
      else {
        return '/img/icons/WEBCLIENT_MimeTypes/ibbFile.svg';
      }
    }
  },
  methods: {
    ...mapMutations(['closeHovers']),
    humanTime: function () {
      return moment(this.modified * 1000).format('DD/MM/YYYY HH:mm:ss');
    },
    humanSize: function () {
      return filesize(this.size);
    },
    download() {
      api.downloadId(this.handle);
      this.$showSuccess(this.$t('transfers.downloadadded'));
    },
    preview() {
      this.$router.push({path: this.$route.path + '#' + this.handle});
    },
    async deleteVersion() {
      await ibb.deleteNode(this.handle); 
      this.$emit('remove-version');
    }
  }
};
</script>